import { useLoggedInHasJira } from "@/components/user-context/helpers/cohorts";
import {
    filterAvailableJiraSites,
    type UserProfileExistingSites
} from "@/templates/software/jira/logged-in/utils/use-recent-jira-site";
import { checkFeatureFlagGate } from "@/utils/feature-flags/check-feature-flag";
import { featureFlags } from "@/utils/feature-flags/feature-flag-manifest";

import {
    ActivationChecklistAaExposurePlacement,
    ActivationChecklistMainPlacement
} from "./activation-checklist-placement";

type ActivationChecklistLoggedInHeroPlacementProps = {
    siteUrl: string;
    cloudSiteId?: string;
    recentWorkUrl?: string;
    existingSites?: UserProfileExistingSites[];
};

export const ActivationChecklistLoggedInHeroPlacement = ({
    siteUrl,
    cloudSiteId,
    recentWorkUrl,
    existingSites
}: ActivationChecklistLoggedInHeroPlacementProps) => {
    const gateEnabled = checkFeatureFlagGate(
        featureFlags.jiraWacActivationChecklistGate
    );
    const aaGateEnabled = checkFeatureFlagGate(
        featureFlags.jiraWacActivationChecklistAaGate
    );
    const loggedInHasJira = useLoggedInHasJira();

    if (
        (gateEnabled !== true && aaGateEnabled !== true) ||
        loggedInHasJira !== true
    ) {
        return null;
    }

    if (!cloudSiteId) {
        return null;
    }

    const jiraSite =
        gateEnabled === true
            ? filterAvailableJiraSites(existingSites).find(
                  (site) => site.cloudId === cloudSiteId
              )
            : undefined;

    return (
        <div data-activation-checklist-placement-root>
            {aaGateEnabled === true ? (
                <ActivationChecklistAaExposurePlacement
                    cloudSiteId={cloudSiteId}
                />
            ) : null}
            {gateEnabled === true ? (
                <ActivationChecklistMainPlacement
                    siteUrl={siteUrl}
                    cloudSiteId={cloudSiteId}
                    recentWorkUrl={recentWorkUrl}
                    canInviteTeam={jiraSite?.hasAdminAccess === true}
                />
            ) : null}
        </div>
    );
};

ActivationChecklistLoggedInHeroPlacement.displayName =
    "ActivationChecklistLoggedInHeroPlacement";
